//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import InputField from '../fields/InputField.vue';
import TextField from '../fields/TextField.vue';
import FileField from '../fields/FileField.vue';
import CheckboxField from '../fields/CheckboxField.vue';
import SelectField from '../fields/SelectField.vue';
import MultiCheckboxField from '../fields/MultiCheckboxField.vue';

export default {
  name: 'NewSessie',
  components: {
    MultiCheckboxField,
    InputField,
    TextField,
    FileField,
    CheckboxField,
    SelectField,
  },
  props: {
    expert: String,
    ajax: String,
    handleSuccess: Function,
  },
  data: function () {
    return {
      loading: true,
      success: false,
      error: false,
      option_topics: [],
      option_expertises: [],
      option_language: [
        { value: 'nl', label: 'Nederlands' },
        { value: 'gb', label: 'Engels' },
        { value: 'de', label: 'Duits' },
        { value: 'es', label: 'Spaans' },
      ],
      title: {
        value: '',
        error: '',
      },
      price: {
        value: '',
        error: '',
      },
      type: {
        value: '',
        error: '',
      },
      content: {
        value: '',
        error: '',
      },
      leerdoelen: {
        value: '',
        error: '',
      },
      doelgroep: {
        value: '',
        error: '',
      },
      language: {
        value: '',
        error: '',
      },
      excerpt: {
        value: '',
        error: '',
      },
      topic: {
        value: '',
        error: '',
      },
      expertises: {
        value: [],
        error: '',
      },
      thumbnail: {
        value: '',
        error: '',
      },
      // gallery: {
      //   value: [],
      //   error: '',
      // },
      youtube: {
        value: '',
        error: '',
      },
      max_participants: {
        value: 10,
        error: '',
      },
      privacy_policy: {
        value: false,
        error: '',
      },
    };
  },
  methods: {
    handleSubmit: function (e) {
      e.preventDefault();

      this.success = false;
      this.error = false;

      const {
        title,
        price,
        type,
        content,
        leerdoelen,
        doelgroep,
        language,
        excerpt,
        topic,
        expertises,
        thumbnail,
        youtube,
        max_participants,
        privacy_policy,
      } = this;

      if (title.value == '') {
        title.error = 'Titel is verplicht.';
        this.error = true;
      } else if (title.value.length > 60) {
        title.error = 'Titel is te lang.';
        this.error = true;
      } else {
        title.error = '';
      }

      if (type.value == '') {
        type.error = 'Soort is verplicht.';
        this.error = true;
      } else {
        type.error = '';
      }

      if (price.value == '') {
        price.error = 'Kosten tafelsessie is verplicht.';
        this.error = true;
      } else if (price.value < (type.value.code == 'groepssessie' ? 250 : 50)) {
        price.error = `De minimale prijs is € ${type.value.code == 'groepssessie' ? '250' : '50'}.`;
        this.error = true;
      } else {
        price.error = '';
      }

      if (excerpt.value == '') {
        excerpt.error = 'Samenvatting is verplicht.';
        this.error = true;
      } else if (excerpt.value.length > 150) {
        excerpt.error = 'Samenvatting is te lang.';
        this.error = true;
      } else {
        excerpt.error = '';
      }

      if (content.value == '') {
        content.error = 'Beschrijving is verplicht.';
        this.error = true;
      } else if (content.value.length > 2250) {
        content.error = 'Beschrijving is te lang.';
        this.error = true;
      } else {
        content.error = '';
      }

      if (topic.value == '') {
        topic.error = 'Vakgebied is verplicht.';
        this.error = true;
      } else {
        topic.error = '';
      }

      if (thumbnail.value.length !== 1) {
        thumbnail.error = 'Header foto is verplicht.';
        this.error = true;
      } else {
        thumbnail.error = '';
      }

      if (max_participants.value < 10) {
        max_participants.error = 'Maximaal aantal deelnemers moet minimaal 10 zijn.';
        this.error = true;
      } else {
        max_participants.error = '';
      }

      if (privacy_policy.value !== true) {
        privacy_policy.error = 'Je moet akkoord gaan met de privacybeleid.';
        this.error = true;
      } else {
        privacy_policy.error = '';
      }

      if (this.error) {
        return false;
      }

      const thumbnail_data = {
        'id': null,
        'filenameWithoutExtension': thumbnail.value[0].filenameWithoutExtension,
        'fileExtension': thumbnail.value[0].fileExtension,
        'fileType': thumbnail.value[0].fileType,
        'fileSize': thumbnail.value[0].fileSize,
        'filename': thumbnail.value[0].filename,
        'data': thumbnail.value[0].getFileEncodeBase64String(),
      };

      // let gallery_data = [];
      // gallery.value.forEach(image => {
      //   gallery_data.push({
      //     'id': null,
      //     'filenameWithoutExtension': image.filenameWithoutExtension,
      //     'fileExtension': image.fileExtension,
      //     'fileType': image.fileType,
      //     'fileSize': image.fileSize,
      //     'filename': image.filename,
      //     'data': image.getFileEncodeBase64String(),
      //   });
      // });

      const formData = new FormData();
      formData.append('expert', this.expert);
      formData.append('title', title.value);
      formData.append('price', price.value);
      formData.append('type', type.value.code);
      formData.append('content', content.value);
      formData.append('leerdoelen', leerdoelen.value);
      formData.append('doelgroep', doelgroep.value);
      formData.append('language', language.value);
      formData.append('excerpt', excerpt.value);
      formData.append('topic', topic.value.code);
      formData.append('expertises', expertises.value);
      formData.append('thumbnail', JSON.stringify(thumbnail_data));
      // formData.append('gallery', JSON.stringify(gallery_data));
      formData.append('youtube', youtube.value);
      formData.append('max_participants', max_participants.value);
      formData.append('privacy_policy', privacy_policy.value);

      axios({
        method: 'post',
        url: `${this.ajax}?action=new_sessie`,
        data: formData,
        headers: {
          'Content-type': 'application/json',
        },
      }).then(res => {
        const { id } = res.data;

        title.value = '';
        price.value = '';
        content.value = '';
        leerdoelen.value = '';
        doelgroep.value = '';
        language.value = '';
        excerpt.value = '';
        topic.value = '';
        expertises.value = [];
        thumbnail.value = '';
        // gallery.value = [];
        youtube.value = '';
        max_participants.value = 10;
        privacy_policy.value = false;

        this.handleSuccess(id);
        this.success = true;
      }).catch(() => {
        this.error = true;
      });
    },
  },
  created: function () {
    this.topics = [];
    this.loading = true;
    axios.get(`${this.ajax}?action=sessie_topics_expertises`).then(res => {
      this.option_topics = res.data.topics.map(topic => {
        return {
          label: topic.name,
          code: topic.term_id,
        };
      });
      this.option_expertises = res.data.expertises.map(expertise => {
        return expertise.name;
      });
      this.loading = false;
    }).catch(error => {
      console.log(error);
      this.loading = false;
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Sessies/NewSessie.vue